import { render, staticRenderFns } from "./CollapsibleBars.vue?vue&type=template&id=0dc13014&"
import script from "./CollapsibleBars.vue?vue&type=script&lang=js&"
export * from "./CollapsibleBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports